import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=3be9b8ce&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=3be9b8ce&prod&lang=scss"
import style1 from "./Search.vue?vue&type=style&index=1&id=3be9b8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be9b8ce",
  null
  
)

export default component.exports